import React, { useEffect } from "react";
import ViolationsDrawer from "./ViolationsDrawer";
import { useGetViolationsForDeviceQuery } from "../../store/api/audit/goldenAuditViolationsApiSlice";

interface ViolationsDrawerWrapperProps {
  open: boolean;
  onClose: () => void;
  deviceKey: string;
  deviceLabel: string;
}

const ViolationsDrawerWrapper: React.FC<ViolationsDrawerWrapperProps> = ({ open, onClose, deviceKey, deviceLabel }) => {
  const { data = [], refetch } = useGetViolationsForDeviceQuery(
    { deviceKey },
    {
      skip: !open,
      pollingInterval: open ? 10000 : 0,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (open) {
      refetch();
    }
  }, [open, refetch]);

  const violations = data.map((violation) => ({
    datamodelKey: violation.datamodelKey,
    expectedValue: violation.expectedValue,
    actualValue: violation.actualValue,
    definitionId: violation.rule?.definition?.id ?? violation.definitionId ?? 0,
    definitionName: violation.rule?.definition?.templatename ?? "Definition Undefined",
    lastRunAt: violation.lastRunAt ?? violation.rule?.definition?.lastScheduledRunAt,
  }));

  return (
    <ViolationsDrawer
      open={open}
      onClose={onClose}
      violations={violations}
      deviceKey={deviceKey}
      deviceLabel={deviceLabel}
    />
  );
};

export default ViolationsDrawerWrapper;
